import React from "react"
import {useIntl, FormattedMessage} from 'react-intl';
import PopupLink from "./PopupLink.js";

function Footer(props) {
	const labels = {
		"wet.appFooter.contactUs.link" : useIntl().formatMessage({id: "wet.appFooter.contactUs.link"})
		, "wet.appFooter.departmentsAndAgencies.link" : useIntl().formatMessage({id: "wet.appFooter.departmentsAndAgencies.link"})
		, "wet.appFooter.publicServiceAndMilitary.link" : useIntl().formatMessage({id: "wet.appFooter.publicServiceAndMilitary.link"})
		, "wet.appFooter.news.link" : useIntl().formatMessage({id: "wet.appFooter.news.link"})
		, "wet.appFooter.treatiesLawsAndRegulations.link" : useIntl().formatMessage({id: "wet.appFooter.treatiesLawsAndRegulations.link"})
		, "wet.appFooter.governmentWideReporting.link" : useIntl().formatMessage({id: "wet.appFooter.governmentWideReporting.link"})
		, "wet.appFooter.primeMinister.link" : useIntl().formatMessage({id: "wet.appFooter.primeMinister.link"})
		, "wet.appFooter.howGovernmentWorks.link" : useIntl().formatMessage({id: "wet.appFooter.howGovernmentWorks.link"})
		, "wet.appFooter.openGovernment.link" : useIntl().formatMessage({id: "wet.appFooter.openGovernment.link"})
		, "wet.appFooter.socialMedia.link" : useIntl().formatMessage({id: "wet.appFooter.socialMedia.link"})
		, "wet.appFooter.mobileApplications.link" : useIntl().formatMessage({id: "wet.appFooter.mobileApplications.link"})
		, "wet.appFooter.aboutCanada_ca.link" : useIntl().formatMessage({id: "wet.appFooter.aboutCanada_ca.link"})
		, "wet.appFooter.termsAndConditions.link" : useIntl().formatMessage({id: "wet.appFooter.termsAndConditions.link"})
		, "wet.appFooter.privacy.link" : useIntl().formatMessage({id: "wet.appFooter.privacy.link"})
	}

	return (
		<>
		  <footer id="wb-info" style={{zIndex: 600}}>
		    <div className="landscape">
		      <nav className="container wb-navcurr">
		        <h2 className="wb-inv"><FormattedMessage id="wet.aboutGovernment"/></h2>
		        <ul className="list-unstyled colcount-sm-2 colcount-md-3">
		          <li>
				  	<PopupLink url={labels["wet.appFooter.contactUs.link"]}>
						<FormattedMessage id="wet.contactUs" />
					</PopupLink>
				  </li>
				  <li>
				  	<PopupLink url={labels["wet.appFooter.departmentsAndAgencies.link"]}>
						<FormattedMessage id="wet.departmentsAndAgencies" />
					</PopupLink>
				  </li>
		          <li>
				  	<PopupLink url={labels["wet.appFooter.publicServiceAndMilitary.link"]}>
						<FormattedMessage id="wet.publicServiceAndMilitary" />
					</PopupLink>
				  </li>
		          <li>
				  	<PopupLink url={labels["wet.appFooter.news.link"]}>
						<FormattedMessage id="wet.news" />
					</PopupLink>
				  </li>
		          <li>
				  	<PopupLink url={labels["wet.appFooter.treatiesLawsAndRegulations.link"]}>
						<FormattedMessage id="wet.treatiesLawsAndRegulations" />
					</PopupLink>
				  </li>
		          <li>
				  	<PopupLink url={labels["wet.appFooter.governmentWideReporting.link"]}>
						<FormattedMessage id="wet.governmentWideReporting" />
					</PopupLink>
				  </li>
		          <li>
				  	<PopupLink url={labels["wet.appFooter.primeMinister.link"]}>
						<FormattedMessage id="wet.primeMinister" />
					</PopupLink>
				  </li>
		          <li>
				  	<PopupLink url={labels["wet.appFooter.howGovernmentWorks.link"]}>
						<FormattedMessage id="wet.howGovernmentWorks" />
					</PopupLink>
				  </li>
		          <li>
				  	<PopupLink url={labels["wet.appFooter.openGovernment.link"]}>
						<FormattedMessage id="wet.openGovernment" />
					</PopupLink>
				  </li>
		        </ul>
		      </nav>
		    </div>
		    <div className="brand">
		      <div className="container">
		        <div className="row">
		          <nav className="col-md-9 col-lg-10 ftr-urlt-lnk">
		            <h2 className="wb-inv"><FormattedMessage id="wet.aboutThisSite"/></h2>
		            <ul>
		              <li>
					 	<PopupLink url={labels["wet.appFooter.socialMedia.link"]}>
							<FormattedMessage id="wet.socialMedia" />
						</PopupLink>
					  </li>
		              <li>
					  	<PopupLink url={labels["wet.appFooter.mobileApplications.link"]}>
							<FormattedMessage id="wet.mobileApplications" />
						</PopupLink>
					  </li>
		              <li>
					  	<PopupLink url={labels["wet.appFooter.aboutCanada_ca.link"]}>
							<FormattedMessage id="wet.aboutCanada_ca" />
						</PopupLink>
					  </li>
		              <li>
					  	<PopupLink url={labels["wet.appFooter.termsAndConditions.link"]}>
							<FormattedMessage id="wet.termsAndConditions" />
						</PopupLink>
					  </li>
		              <li>
					  	<PopupLink url={labels["wet.appFooter.privacy.link"]}>
							<FormattedMessage id="wet.appFooter.privacy" />
						</PopupLink>
					  </li>
		            </ul>
		          </nav>
		          <div className="col-xs-6 visible-sm visible-xs tofpg"> <a href="#wb-cont"><FormattedMessage id="wet.topOfPage"/> <span className="glyphicon glyphicon-chevron-up"></span></a> </div>
		          <div className="col-xs-6 col-md-3 col-lg-2 text-right"> <img src="./GCWeb/assets/wmms-blk.svg" alt={useIntl().formatMessage({id:"wet.symbolOfTheGovernmentOfCanada"})}/> </div>
		        </div>
		      </div>
		    </div>
		  </footer>
		</>
	);
}

export default Footer;